import { render } from "./LoyaltyRewardLevels.vue?vue&type=template&id=85529d36&scoped=true"
import script from "./LoyaltyRewardLevels.vue?vue&type=script&lang=js"
export * from "./LoyaltyRewardLevels.vue?vue&type=script&lang=js"

import "./LoyaltyRewardLevels.vue?vue&type=style&index=0&id=85529d36&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85529d36"]])

export default __exports__